require('./web/jquery.webslider');
const $ = require('jquery');
// shimované pluginy většinou nemají export, většinou extendují jQuery object
require('fg-frontend/ramjet/liveValidation');
const TargetBlankAutoTitle = require('fg-frontend/plugins/required/targetBlankAutoTitle');
const PhoneLinkActivation = require('fg-frontend/plugins/required/phoneLinkActivation');
// require('fg-frontend/plugins/required/jquery.cookies-policy');
// require('./web/jquery.cookies-policy');
require('./web/highslide-settings');
require('bootstrap/collapse');
require('jquery-ui/datepicker');
require('./web/datepicker-cs');
// require('fg-frontend/third/jquery-ui/datetimePicker/timepicker');
// require('fg-frontend/third/jquery-ui/datetimePicker/localization/timepicker-cs');

require('./third/plUpload/fg.upload');

// window.Director = require('./web/Director');
window.AnchorSlider = require('./web/AnchorSlider');

require('./web/jquery.gm');
require('./web/jquery.jspagination');
require('./web/jquery.universalPagination');
// require('./web/jquery.swipebox');
require('selectize');
const isMobile = require('./web/isMobile');

require('fg-frontend/ramjet/partialUpdate'); // musí zůstat jako poslední require

// export to window
window.$ = $;
window.jQuery = $;
projectConfig.googlemaps = window.projectConfig.googlemaps || {};

const $b = $('body');
const $w = $(window);
const $d = $(document);

window.anchorSliderInstance = new window.AnchorSlider();
window.anchorSliderInstance.init();

/**
 * Promění definovaný selektor (span.phone-number je default, z této definice je možné smazat) v odkazy s telefonním číslem.
 * Pouze na mobilních telefonech. Automaticky se mění i po přidání do DOMu. Pokud z nějakého důvodu nefunguje,
 * je možné pořešit pomocí phoneLink.getRelevantElements()
 */
const phoneLink = new PhoneLinkActivation(document.body, {
  selector: 'span.phone-number', // vymezit selektor, kde chceme použít transformaci čísla na odkaz
  linkClassName: 'phone-number', // třída, která bude vložena na výsledný odkaz (kvůli případnému stylování)
  domChange: true, // flag, zda chceme měnit čísla on the fly i po změně DOMu.
  // Pokud ne, phoneLink.getRelevantElements()
});
// window.phoneLink = phoneLink;    // toto není nutné zapínat, pokud nepotřebujeme manuálně volat změnu

/*
 * Pokud máte na stránce anchor s target="blank" atributem, který nemá vyplněný title, nasadí se na něj
 * automaticky titulek ve smyslu "Otevře se v novém okně" dle langu stránky (atribut html lang).
 * Texty jsou definované ve třídě TargetBlankAutoTitle. Lze je definovat ručně při incicalizaci
 * např:  $("body").targetBlankAutoTitle({labels: {cs: "Lorem ipsum", sk: "Dolor sit"}});
 *
 * Pro weby mimo standardní kolekci jazyků (en, de, sk, cz) doporučuji překlad korekturovat.
 * Byl pouze automaticky přeložen.
 *
 * Korekturované překlady můžete dávat do issue https://ep.fg.cz/issues/60227
 *
 * Zkratky jazyků jsou z ISO 639-1 normy
 */
window.targetBlankAutoTitle = new TargetBlankAutoTitle();

/**
 * Dynamicky donačtený s postupným dojezem na stránku
 */
window.isElementInViewport = function (el) {
  let top = el.offsetTop;
  let left = el.offsetLeft;
  const width = el.offsetWidth;
  const height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth) &&
    (top + height) > window.pageYOffset &&
    (left + width) > window.pageXOffset
  );
};

window.checkElementInViewportAndSetClass = function (time) {
  $('.js_addClassWhenIsInUserView').each(function () {
    if (isElementInViewport(this) === true) {
      const $t = $(this);
      window.setTimeout(() => {
        $t.addClass('show-and-move-up');
      }, time);
    }
  });
};
$(window).scroll(() => {
  checkElementInViewportAndSetClass(200);
});
checkElementInViewportAndSetClass(0);


/**
 * Google maps
 */
$.googlemap.setDefaults({
  mapOptions: {
    scrollwheel: false,
  },
  markerTypes: [
    {},
    {
      icon: {
        url: '/img/google-map/marker-vez.png',
        size: new google.maps.Size(44, 56),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(22, 56),
      },
      shape: {
        coords: [0, 0, 44, 56],
        type: 'rect',
      },
    }, {
      icon: {
        url: '/img/google-map/marker-02.png',
        size: new google.maps.Size(44, 56),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(22, 64),
      },
      shape: {
        coords: [0, 0, 44, 56],
        type: 'rect',
      },
    }, {
      icon: {
        url: '/img/google-map/marker-03.png',
        size: new google.maps.Size(44, 56),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(22, 64),
      },
      shape: {
        coords: [0, 0, 44, 56],
        type: 'rect',
      },
    }, {
      icon: {
        url: '/img/google-map/marker-04.png',
        size: new google.maps.Size(44, 56),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(22, 64),
      },
      shape: {
        coords: [0, 0, 44, 56],
        type: 'rect',
      },
    }, {
      icon: {
        url: '/img/google-map/marker-05.png',
        size: new google.maps.Size(44, 56),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(22, 64),
      },
      shape: {
        coords: [0, 0, 44, 56],
        type: 'rect',
      },
    }, {
      icon: {
        url: '/img/google-map/marker-06.png',
        size: new google.maps.Size(44, 56),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(22, 64),
      },
      shape: {
        coords: [0, 0, 44, 56],
        type: 'rect',
      },
    },
  ],
  bubbleContentFormatter(mData) {
    let str = '';
    if (mData.title) { str += `<p class="h4">${mData.title}</p>`; }
    if (mData.bubbleContent) { str += mData.bubbleContent; }
    return str;
  },
});


/**
 * Ovládání RWD menu
 */
const controlMenu = function () {
  const visitedMenu = false;

  const init = function () {
    $b.on('click', '.js_menuBurger', function (e) {
      $(this).toggleClass('close');
      $('.js_navigation').toggleClass('show-navigation');
      $('.js_header').toggleClass('header-auto');
      e.preventDefault();
    });
    $b.on('click', '.js_navigation .js_anchorSlide-goTo', () => {
      $('.js_menuBurger').toggleClass('close');
      $('.js_navigation').toggleClass('show-navigation');
      $('.js_header').toggleClass('header-auto');
    });
  };

  init();
};


/**
 * Ovládání RWD menu
 */
const stickyMenu = function () {
  const init = function () {
    const pageTopOffset = $('.js_page').offset().top;
    const scrollTop = $w.scrollTop();
    if (scrollTop > pageTopOffset) {
      $('.js_header').addClass('sticky');
    } else {
      $('.js_header').removeClass('sticky');
    }
  };
  $w.scroll(() => {
    init();
  });
  init();
};

/**
 * scrollToAnchor
 */
const scrollToAnchor = function () {
  const init = function () {
    $('a[href^="/cs/#"]').on('click', (e) => {
      e.preventDefault();
      /*
      $('html, body').animate({
        scrollTop: $("#div1").offset().top
      }, 1000);
*/
    });
  };

  init();
};


/**
 * Stránkování
 */
/*
$('.js_pagination-gallery').jspagination({
  pageSize: 12,
  itemSelector: '.item',
  nextButtonSelector: '.js_pagination-gallery-button',
  autoPreloadHistory: false,
  onAfterShowPage: function() {
    var topOffset = $(window).scrollTop();
    $(window).scrollTop(topOffset+1);
    $(window).scrollTop(topOffset);
  }
});
*/


/**
 * Tlačítko zpět
 */
/*
$('.js_back-button').backButton();
*/


/**
 * Init
 */
controlMenu();
stickyMenu();
// inicializace Swipebox pluginu (fotogalerie)
// $('.swipebox').swipebox();

$(document).bind('afterContentsReplaced', () => {
  if (!isMobile.phone && !isMobile.tablet) {
    $('form select').selectize();
  }
});
if (!isMobile.phone && !isMobile.tablet) {
  $('form select').selectize();
}
$d.on('click', '.plupload label', (e) => {
  e.preventDefault();
});

// Disable scroll zooming and bind back the click event
if (isMobile.phone || isMobile.tablet) {
  if ($('.js_gm .google-map').length) { $('.js_gm .google-map').css('pointer-events', 'none'); }

  var onMapMouseleaveHandler = function (event) {
    const that = $(this);

    that.on('click', onMapClickHandler);
    that.off('mouseleave', onMapMouseleaveHandler);
    that.find('.google-map').css('pointer-events', 'none');
  };

  var onMapClickHandler = function (event) {
    const that = $(this);

    // Disable the click handler until the user leaves the map area
    that.off('click', onMapClickHandler);

    // Enable scrolling zoom
    that.find('.google-map').css('pointer-events', 'auto');

    // Handle the mouse leave event
    that.on('mouseleave', onMapMouseleaveHandler);
  };

  // Enable map zooming with mouse scroll when the user clicks the map
  $('.js_gm').on('click', onMapClickHandler);
}

// scrollToAnchor();

function initCollapse({
						  container,
						  activeItemClassName = 'active',
						  allowOneActiveItem = false,
						  openItemOnLoad = true,
						  waiAriaControls = 'aria-controls',
						  waiAriaLabelledby = 'aria-labelledby',
						  waiAriaExpanded = 'aria-expanded',
					  } = {}) {
  if (!container) return;

  const buttons = Array.from(container.querySelectorAll(`[${waiAriaControls}]`));

  function getElementTarget(button) {
    const targetId = button.getAttribute(waiAriaControls);
    return container.querySelector(`#${targetId}`);
  }

  function showContent(button) {
    button.setAttribute(waiAriaExpanded, 'true');
    const target = getElementTarget(button);
    if (target) target.classList.add(activeItemClassName);
  }

  function hideContent(button) {
    button.setAttribute(waiAriaExpanded, 'false');
    const target = getElementTarget(button);
    if (target) target.classList.remove(activeItemClassName);
  }

  function handleClick(e) {
    const button = e.currentTarget;
    const expanded = button.getAttribute(waiAriaExpanded) === 'true';

    if (allowOneActiveItem) {
      buttons.forEach((btn) => {
        if (btn !== button) hideContent(btn);
      });
    }

    if (expanded) {
      hideContent(button);
    } else {
      showContent(button);
    }
  }

  function handleLoad() {
    if (!openItemOnLoad) return;

    const hash = location.hash && location.hash.substring(1);
    if (!hash) return;

    const anchorElement = container.querySelector(`#${hash}`);
    if (!anchorElement) return;

    const buttonId = anchorElement.getAttribute(waiAriaLabelledby);
    const button = buttonId
      ? container.querySelector(`#${buttonId}`)
      : container.querySelector(`[${waiAriaControls}="${hash}"]`);

    if (button) {
      button.dispatchEvent(new Event('click'));
      button.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function handleKeydown(e) {
    if (e.key !== 'Escape') return;

    buttons.forEach((button) => {
      const expanded = button.getAttribute(waiAriaExpanded) === 'true';
      if (expanded) {
        hideContent(button);
      }
    });
  }

  // Event listenery
  buttons.forEach((button) => {
    button.addEventListener('click', handleClick);
  });

  window.addEventListener('load', handleLoad);
  document.addEventListener('keydown', handleKeydown);

  // Volitelný clean-up
  return () => {
    buttons.forEach((button) => {
      button.removeEventListener('click', handleClick);
    });
    window.removeEventListener('load', handleLoad);
    document.removeEventListener('keydown', handleKeydown);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const langswitchElements = document.querySelectorAll('.langswitch');
  langswitchElements.forEach((langswitch) => {
    initCollapse({ container: langswitch });
  });
});

/*
function initCollapse({
						  container,
						  activeItemClassName = 'active',
						  allowOneActiveItem = false,
						  openItemOnLoad = true,
						  waiAriaControls = 'aria-controls',
						  waiAriaLabelledby = 'aria-labelledby',
						  waiAriaExpanded = 'aria-expanded',
					  } = {}) {
  if (!container) return;

  // const BUTTON_SELECTOR = '[data-fragment="Collapse.button"]';
  // const buttons = container.querySelectorAll(BUTTON_SELECTOR);
  const buttons = Array.from(container.querySelectorAll('[aria-controls]'));

  function getElementTarget(button) {
    const targetId = button.getAttribute(waiAriaControls);
    console.log(targetId);
    return container.querySelector(`#${targetId}`);
  }

  function showContent(button) {
    button.setAttribute(waiAriaExpanded, 'true');
    const target = getElementTarget(button);
    if (target) target.classList.add(activeItemClassName);
    if (target) this.getElementTarget(buttonElement).classList.add(activeItemClassName);
  }

  function hideContent(button) {
    button.setAttribute(waiAriaExpanded, 'false');
    const target = getElementTarget(button);
    if (target) target.classList.remove(activeItemClassName);
  }

  function handleClick(e) {
    const button = e.currentTarget; // <- Tohle je přímo ten button, ne svg uvnitř

    const expanded = button.getAttribute(waiAriaExpanded) === 'true';

    if (allowOneActiveItem) {
      buttons.forEach((btn) => {
        if (btn !== button) {
          hideContent(btn);
        }
      });
    }

    if (expanded) {
      hideContent(button);
    } else {
      showContent(button);
    }
  }

  function handleLoad() {
    if (!openItemOnLoad) return;

    const hash = location.hash && location.hash.substring(1);
    if (!hash) return;

    const anchorElement = container.querySelector(`#${hash}`);
    if (!anchorElement) return;

    const buttonId = anchorElement.getAttribute(waiAriaLabelledby);
    const button = buttonId
      ? container.querySelector(`#${buttonId}`)
      : container.querySelector(`#${hash}`);

    if (button) {
      button.dispatchEvent(new Event('click'));
      button.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // Připojení event listenerů
  buttons.forEach((button) => {
    button.addEventListener('click', handleClick);
  });

  window.addEventListener('load', handleLoad);

  // Volitelně: vrací funkci pro odpojení (clean-up)
  return () => {
    buttons.forEach((button) => {
      button.removeEventListener('click', handleClick);
    });
    window.removeEventListener('load', handleLoad);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const langswitch = document.querySelector('.langswitch');
  if (langswitch) {
    initCollapse({ container: langswitch });
  }
});
*/

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
$.each(q, (index, f) => {
  $(f);
});




// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js